var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
//@ts-ignore
import RelativePortal from 'react-relative-portal';
import { getTagLongName } from '@data/tag/tagUtil';
import { RiArrowRightSFill } from 'react-icons/ri';
//@ts-ignore
import { FixedSizeList as List } from 'react-window';
import { FaArrowAltCircleLeft, FaArrowAltCircleRight } from 'react-icons/fa';
var WIDTH = 420;
var LIST_HEIGHT = 220;
function Suggestions(_a) {
    var suggestions = _a.suggestions, selectedIndex = _a.selectedIndex, handleClick = _a.handleClick, handleHover = _a.handleHover, classNames = _a.classNames, handleParentTagClick = _a.handleParentTagClick, handleParentTagBackClick = _a.handleParentTagBackClick, parent = _a.parent, containerRef = _a.containerRef;
    var _b = __read(useState({ left: 0, top: 10 }), 2), position = _b[0], setPosition = _b[1];
    useEffect(function () {
        var _a, _b;
        if (containerRef.current) {
            var rect = (_b = (_a = containerRef.current).getBoundingClientRect) === null || _b === void 0 ? void 0 : _b.call(_a);
            if (rect.x + WIDTH > window.innerWidth) {
                setPosition(__assign(__assign({}, position), { left: window.innerWidth - (rect.x + WIDTH + 10) }));
            }
            if (rect.y + LIST_HEIGHT > window.innerHeight) {
                setPosition(__assign(__assign({}, position), { top: position.top - (LIST_HEIGHT + 34) }));
            }
        }
    }, []);
    if (suggestions.length === 0) {
        return null;
    }
    return (React.createElement(RelativePortal, { component: "div", left: position.left, top: position.top },
        React.createElement("div", { className: classNames.suggestions },
            parent && (React.createElement("div", { className: "tag-suggestions-back", style: { height: 28, width: WIDTH } },
                React.createElement("button", { onMouseDown: function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        handleParentTagBackClick();
                    } },
                    React.createElement(FaArrowAltCircleLeft, { size: 16 })),
                parent)),
            React.createElement(List, { height: LIST_HEIGHT, itemCount: suggestions.length, itemSize: 28, width: WIDTH }, function (_a) {
                var index = _a.index, style = _a.style;
                return (React.createElement("div", { className: "".concat(classNames.suggestionsItem).concat(suggestions[index].disabled ? ' disabled ' : '').concat(index === selectedIndex ? ' active' : ''), onMouseOver: function () { return handleHover(index); }, onMouseDown: function () { return handleClick(index); }, style: __assign(__assign({}, style), { paddingLeft: 4 + suggestions[index].depth * 12 }) },
                    React.createElement(RiArrowRightSFill, { size: 12 }),
                    React.createElement("span", null, getTagLongName(suggestions[index].tag)),
                    suggestions[index].hasChildren && (React.createElement("button", { onMouseDown: function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            handleParentTagClick(index);
                        } },
                        React.createElement(FaArrowAltCircleRight, { size: 16 })))));
            }))));
}
export default Suggestions;
